module.exports = __webpack_public_path__ + "img/image5.4044c112.jpg";